module.exports = __webpack_public_path__ + "static/our-story-0439d1eb255a72cb8a2e263cf70f6e0c.jpg";